import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const SmileyLight = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M11.99 2.45117C6.47 2.45117 2 6.93117 2 12.4512C2 17.9712 6.47 22.4512 11.99 22.4512C17.52 22.4512 22 17.9712 22 12.4512C22 6.93117 17.52 2.45117 11.99 2.45117ZM12 20.4512C7.58 20.4512 4 16.8712 4 12.4512C4 8.03117 7.58 4.45117 12 4.45117C16.42 4.45117 20 8.03117 20 12.4512C20 16.8712 16.42 20.4512 12 20.4512ZM15.5 11.4512C16.33 11.4512 17 10.7812 17 9.95117C17 9.12117 16.33 8.45117 15.5 8.45117C14.67 8.45117 14 9.12117 14 9.95117C14 10.7812 14.67 11.4512 15.5 11.4512ZM8.5 11.4512C9.33 11.4512 10 10.7812 10 9.95117C10 9.12117 9.33 8.45117 8.5 8.45117C7.67 8.45117 7 9.12117 7 9.95117C7 10.7812 7.67 11.4512 8.5 11.4512ZM12 17.9512C14.33 17.9512 16.31 16.4912 17.11 14.4512H6.89C7.69 16.4912 9.67 17.9512 12 17.9512Z"
    />
  </svg>
);
